import { connect } from 'react-redux';
import PersonDetailTabs from './PersonDetailTabs';
import {
    getPersonDetailBegin,
    getPersonContactsBegin,
    getLicenseListAppointmentBegin,
    addAppointmentBegin,
    getPersonLicensesBegin,
    getAppointmentTypeListBegin,
    getPersonFileListBegin,
    addBulkAppointmentBegin,
    getPersonTypesBegin,
} from '../../store/actions/person.actions';
import { getInspectionTypeBegin, getUserListBegin } from '../../store/actions/license.actions';
import { getInspectionType, getUserList } from '../../store/selectors/license.selectors';

import {
    getPersonDetailLoading,
    getPersonDetail,
    getPersonEditForm,
    getPersonLicensesList,
    getUpdatePersonLoader,
    getPersonContacts,
    getPersonContactLoader,
    getLicenseListAppointment,
    getAppointmentTypeList,
    getLoadMoreLicense,
    getLoadMoreAppointment,
    getLoadMorePersonContacts,
    getLoadMorePersonComment,
    getLoadMorePersonAccounting,
    getLoadMorePersonFile,
    getAppointmentCount,
    getPersonLicenseCount,
    getPersonContactsCount,
    getPersonLicenseColumnFields,
    getPersonTabs,
    getPersonAccountingErrorStatus,
} from '../../store/selectors/person.selectors';
import {
    getAppointmentListBegin,
    getPersonCommentListBegin,
    getPersonAccountingBegin,
} from '../../store/actions/person.actions';
import { addLicenseBegin, getLicenseTypesBegin, setActiveTab } from '../../store/actions/license.actions';
import { getLicenseTypes } from '../../store/selectors/license.selectors';
import { getSiteFeaturesList } from '../../store/selectors/site.selectors';

const mapStateToProps = (state: any) => {
    const person = getPersonDetail(state);
    const editForm = getPersonEditForm(state);
    const isLoading = getPersonDetailLoading(state);
    const personLicenses = getPersonLicensesList(state);
    const users = getUserList(state);
    const licenseListAppointment = getLicenseListAppointment(state);
    const personUpdateLoadingStatus = getUpdatePersonLoader(state);
    const personContactList = getPersonContacts(state);
    const isPersonContactLoading = getPersonContactLoader(state);
    const licenseTypesList = getLicenseTypes(state);
    const appointmentTypeList = getAppointmentTypeList(state);
    const featureFlags = getSiteFeaturesList(state);
    const hasMoreLicense = getLoadMoreLicense(state);
    const hasMoreAppointment = getLoadMoreAppointment(state);
    const hasMoreContacts = getLoadMorePersonContacts(state);
    const inspectionTypes = getInspectionType(state);
    const hasMorePersonComment = getLoadMorePersonComment(state);
    const hasMoreAccounting = getLoadMorePersonAccounting(state);
    const hasMoreFiles = getLoadMorePersonFile(state);
    const appointmentCount = getAppointmentCount(state);
    const licenseCount = getPersonLicenseCount(state);
    const personContactsCount = getPersonContactsCount(state);
    const personLicenseColumnFields = getPersonLicenseColumnFields(state);
    const configuredTabs = getPersonTabs(state);
    const accountingErrorStatus = getPersonAccountingErrorStatus(state);

    return {
        person,
        editForm,
        isLoading,
        personLicenses,
        personUpdateLoadingStatus,
        personContactList,
        isPersonContactLoading,
        users,
        licenseListAppointment,
        licenseTypesList,
        appointmentTypeList,
        featureFlags,
        hasMoreLicense,
        hasMoreAppointment,
        hasMoreContacts,
        inspectionTypes,
        hasMorePersonComment,
        hasMoreAccounting,
        hasMoreFiles,
        appointmentCount,
        licenseCount,
        personContactsCount,
        personLicenseColumnFields,
        configuredTabs,
        accountingErrorStatus,
    };
};

const mapDispatchToProps = {
    getPerson: getPersonDetailBegin,
    getLicenseList: getPersonLicensesBegin,
    getAppointmentList: getAppointmentListBegin,
    getAppointmentTypeList: getAppointmentTypeListBegin,
    setActiveTab: setActiveTab,
    getPersonContacts: getPersonContactsBegin,
    getUserList: getUserListBegin,
    getLicenseListAppointment: getLicenseListAppointmentBegin,
    addAppointment: addAppointmentBegin,
    getPersonLicensesList: getPersonLicensesBegin,
    getLicenseTypes: getLicenseTypesBegin,
    addLicense: addLicenseBegin,
    personCommentList: getPersonCommentListBegin,
    getInspectionType: getInspectionTypeBegin,
    getPersonAccounting: getPersonAccountingBegin,
    getPersonFileList: getPersonFileListBegin,
    addBulkAppointments: addBulkAppointmentBegin,
    getPersonTypes: getPersonTypesBegin,
};

export default connect(mapStateToProps, mapDispatchToProps)(PersonDetailTabs);
